import { BugReport, PlaylistAdd } from '@mui/icons-material';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import DefaultIcon from '@mui/icons-material/ViewList';
import React from 'react';
import { Layout, Menu, useResourceDefinitions } from 'react-admin';

import { useSelfQuery } from '../../graphql/types';
import { SplitFlags, useFeatureFlags } from '../../hooks/useFeatureFlags';
import { EnvLevel, getEnvLevel } from '../../utils/getEnvLevel';
import AuthLayout from '../AuthLayout';

const CustomMenu: React.FC = (props) => {
  const { flags } = useFeatureFlags();

  const enableTestDataService = flags[SplitFlags.SPA_TEST_DATA_SERVICE];
  const resourcesDefinitions = useResourceDefinitions();
  const resources = Object.keys(resourcesDefinitions).map(
    (name) => resourcesDefinitions[name],
  );

  const { loading, data: selfQueryResponse } = useSelfQuery();

  if (loading && !selfQueryResponse?.self) {
    return <AuthLayout />;
  }

  return (
    <Menu {...props}>
      {resources.map((resource) => (
        <Menu.ResourceItem
          name={resource.name}
          key={resource.name}
          primaryText={resource.options?.label ?? resource.name}
          leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
        />
      ))}
      {/* C U S T O M  R O U T E S */}
      {selfQueryResponse?.self?.isAdmin && (
        <div>
          {(getEnvLevel() === EnvLevel.DEV ||
            getEnvLevel() === EnvLevel.TESTING) &&
            enableTestDataService && (
              <div>
                <Menu.Item
                  primaryText="Test Data"
                  to="/app/testData"
                  leftIcon={<PlaylistAdd />}
                />
              </div>
            )}
          <Menu.Item
            primaryText="Email Debugger"
            to="/app/emailDebugger"
            leftIcon={<BugReport />}
          />
          <Menu.Item
            primaryText="System Preferences"
            to="/app/systemPreferences"
            leftIcon={<SettingsApplicationsIcon />}
          />
        </div>
      )}
    </Menu>
  );
};

export const CustomLayout: React.FC<React.PropsWithChildren> = ({
  children,
  ...rest
}) => (
  <Layout {...rest} menu={CustomMenu}>
    {children}
  </Layout>
);
